export function handleDrawer() {
    return {
        type: 'HANDLE_DRAWER'
    }
}

export function handleMenuTree(idItem) {
    return {
        type: 'HANDLE_MENUTREE',
        payload: idItem
    }
}

export function handleMenuFloat(event) {
    if (event) {
        return {
            type: 'HANDLE_MENUFLOAT',
            payload: event.currentTarget
        }
    } else {
        return {
            type: 'HANDLE_MENUFLOAT',
            payload: ''
        }
    }

}

export function activeItemMenu(e, titleProps) {
    const { index } = titleProps
    return {
        type: 'MENU_CHANGED',
        payload: index
    }
}

export function activeItemSubMenu(e, props) {
    const { name } = props
    return {
        type: 'SUBMENU_CHANGED',
        payload: name
    }
}